import React, { useState } from 'react';
import { Zap, Lock, User, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../AuthContext';
import axios from 'axios';
const api = axios.create({ baseURL: '/api', timeout: 15000 });

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await api.post('/auth/login', { username, password });
      login(r.data.token, r.data.user);
    } catch (err) {
      setError(err.response?.data?.error || '로그인 실패');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#020817', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: '380px', padding: '0 1rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <Zap size={28} color="#38bdf8" />
            <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#f1f5f9', letterSpacing: '-0.5px' }}>NewsMonitor</span>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#475569' }}>뉴스 모니터링 시스템</p>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '1rem', fontWeight: 700, color: '#f1f5f9', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <Lock size={15} color="#38bdf8" /> 로그인
          </h2>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div>
              <div style={{ fontSize: '0.72rem', color: '#64748b', marginBottom: '0.25rem' }}>아이디</div>
              <div style={{ position: 'relative' }}>
                <User size={14} color="#475569" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                <input className="input" value={username} onChange={e => setUsername(e.target.value)}
                  placeholder="아이디 입력" autoFocus required
                  style={{ width: '100%', paddingLeft: '30px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div>
              <div style={{ fontSize: '0.72rem', color: '#64748b', marginBottom: '0.25rem' }}>비밀번호</div>
              <div style={{ position: 'relative' }}>
                <Lock size={14} color="#475569" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                <input className="input" type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="비밀번호 입력" required
                  style={{ width: '100%', paddingLeft: '30px', paddingRight: '36px', boxSizing: 'border-box' }} />
                <button type="button" onClick={() => setShowPw(v => !v)}
                  style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#475569', padding: '2px' }}>
                  {showPw ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>
            {error && <div style={{ fontSize: '0.8rem', color: '#f87171', textAlign: 'center' }}>{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: '0.25rem' }}>
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: '0.75rem', color: '#334155', marginTop: '1.5rem' }}>
          계정 문의: 관리자에게 연락하세요
        </p>
      </div>
    </div>
  );
}
